import BaseEvent from './BaseEvent.js';
import { getOSM, getGUI } from '../../OverworldAnimation.js';
import { RIGHT, UP, LEFT } from '../../constants.js';

export default class SayHiToMom extends BaseEvent {
    constructor({
        identifier = 'say_hi_to_mom',
        isActive = true,
        complete = false,
        autoComplete = true,
        objectsIdentifiers = ['mom'],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
    }

    static deserialize(data) {
        return new SayHiToMom({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();

        // Skip all event actions if the skip overworld events cheat is enabled
        if (osm.shouldSkipOverworldEvents()) {
            return;
        }

        const player = osm.player;
        const gui = getGUI();
        const mom = this.getObject('mom');

        osm.script(() => {
            player.running = false;
            gui.sprites.player.frames.val = 0;
            mom.showExclamationMark();
        });
        osm.delay(30);
        osm.script(() => {
            mom.direction = RIGHT;
        });
        osm.readText(`Hello ${player.name}! You're finally up!`, { speaker: () => mom.name });
        osm.finishReading();
        osm.moveNPC(mom, RIGHT, 6);
        osm.script(() => {
            mom.direction = UP;
        });
        osm.readText('Hopefully you have plenty of energy! It’s gonna be a big day!', { speaker: () => mom.name });
        osm.finishReading();
        osm.moveNPC(mom, LEFT, 6);
        osm.script(() => {
            mom.direction = UP;
        });
    }
}
